import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggle: 'onItemClick'
            }
        }
    }

    init() {
        this.openVideo(this.$('item')[0])
    }

    onItemClick(e) {
        this.openVideo(e.curTarget.parentNode);
    }

    openVideo($item) {
        // Disable current active item(s)
        Array.from(this.$('item.is-active')).forEach($oldItem => {
            // Remove active class
            $oldItem.classList.remove('is-active')
            // Reset height
            const $infos = this.$('infos', $oldItem)[0]
            gsap.to($oldItem, { height: $infos.getBoundingClientRect().height, onComplete: () => {
                gsap.set($oldItem, { clearProps: 'height' })
            } })
            // Stop video
            const $player = this.$('player', $oldItem)[0];
            $player.classList.add('-hide-ui');
            this.call('reset', null, 'VideoPlayer', $player.getAttribute('data-module-video-player'))
        })

        $item.classList.add('is-active')

        const $player = this.$('player', $item)[0];
        $player.classList.remove('-hide-ui');

        gsap.to($item, { height: $player.getBoundingClientRect().height, onComplete: () => {
            this.call('update', null, 'Scroll')
        } })
    }
}
